export default function calculateFinalPrice( extraPrice: string | number, playersPrice: string | number, ): string {
  const price = isNaN( Number( extraPrice, ), ) ? 0 : Number( extraPrice, )

  const priceForPlayersCount = isNaN( Number( playersPrice, ), ) ? 0 : Number( playersPrice, )

  return Number( price + priceForPlayersCount, )
    .toFixed( 2, )
}
